import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';

@Component({
	selector: 'app-shared-breadcrumb',
	standalone: true,
	imports: [CommonModule,RouterModule],
	templateUrl: './shared-breadcrumb.component.html',
	styleUrl: './shared-breadcrumb.component.scss'
})
export class SharedBreadcrumbComponent implements OnInit {

	breadcrumbs: Array<{ label: string; url: string }> = [];

	constructor(
		private router: Router,
		private route: ActivatedRoute
	) { }

	ngOnInit(): void {
		this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe(() => {
				this.breadcrumbs = [];
				this.buildBreadcrumb(this.route.root);
			});
	}

	buildBreadcrumb(route: ActivatedRoute, url: string = '') {
		const children = route.children;

		for (const child of children) {
			const routeURL = child.snapshot.url.map(segment => segment.path).join('/');
			if (routeURL) {
				url += `/${routeURL}`;
			}

			const label = child.snapshot.data['breadcrumb'];
			if (label) {
				this.breadcrumbs.push({ label, url });
			}

			this.buildBreadcrumb(child, url);
		}
	}
}
